module.exports = __webpack_public_path__ + "static/media/watertank.2697cf80.png";